import type { ButtonSize } from "../../../components/common/Button/Button";

export const getHeaderBaseHeight = (innerWidth: number): number | undefined => {
	if (innerWidth < 414) return 88;
	if (innerWidth < 1024) return 104;
	return undefined;
};
export const getButtonSize = (innerWidth: number): ButtonSize => {
	if (innerWidth < 414) return "small";
	return "standard";
};
const MAX_ICON_HEIGHT = 120;
const MIN_ICON_HEIGHT = 80;

const MAX_ICON_HEIGHT_MOBILE = 70;
const MIN_ICON_HEIGHT_MOBILE = 55;

export const getLogoSize = (
	currentSize: number,
	previousScrollY: number,
	currentScrollY: number,
) => {
	const scale = Math.ceil(currentScrollY / 20);

	const scrollDirection = currentScrollY > previousScrollY ? "down" : "up";
	if (currentSize <= MIN_ICON_HEIGHT && scrollDirection === "down") {
		return MIN_ICON_HEIGHT;
	}
	if (currentSize >= MAX_ICON_HEIGHT && scrollDirection === "up") {
		return MAX_ICON_HEIGHT;
	}

	// The user has scrolled down
	if (currentScrollY > previousScrollY + 1) {
		const nextSize = currentSize - scale;
		return nextSize >= MIN_ICON_HEIGHT ? nextSize : MIN_ICON_HEIGHT;
	}
	if (currentScrollY < previousScrollY - 1) {
		const nextSize = currentSize + scale;
		return nextSize <= MAX_ICON_HEIGHT ? nextSize : MAX_ICON_HEIGHT;
	}
	return currentSize;
};

export const getLogoSizeMobile = (
	currentSize: number,
	previousScrollY: number,
	currentScrollY: number,
) => {
	const scale = Math.ceil(currentScrollY / 20);

	const scrollDirection = currentScrollY > previousScrollY ? "down" : "up";
	if (currentSize <= MIN_ICON_HEIGHT_MOBILE && scrollDirection === "down") {
		return MIN_ICON_HEIGHT_MOBILE;
	}
	if (currentSize >= MAX_ICON_HEIGHT_MOBILE && scrollDirection === "up") {
		return MAX_ICON_HEIGHT_MOBILE;
	}

	// The user has scrolled down
	if (currentScrollY > previousScrollY + 1) {
		const nextSize = currentSize - scale;
		return nextSize >= MIN_ICON_HEIGHT_MOBILE
			? nextSize
			: MIN_ICON_HEIGHT_MOBILE;
	}
	if (currentScrollY < previousScrollY - 1) {
		const nextSize = currentSize + scale;
		return nextSize <= MAX_ICON_HEIGHT_MOBILE
			? nextSize
			: MAX_ICON_HEIGHT_MOBILE;
	}
	return currentSize;
};

export const getHeaderSize = (
	currentSize: number | "auto",
	scrollY: number,
	innerWidth: number,
): number | "auto" => {
	if (currentSize === "auto") return currentSize;
	if (scrollY < 50 && innerWidth < 1024) {
		return getHeaderBaseHeight(innerWidth) - scrollY / 2;
	}
	return currentSize;
};
